module.exports = __webpack_public_path__ + "img/4.b9271423.jpeg";